import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=f96cbcce&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f96cbcce')) {
      api.createRecord('f96cbcce', component.options)
    } else {
      api.reload('f96cbcce', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=f96cbcce&", function () {
      api.rerender('f96cbcce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KbbYM7UFpNkf/JS/pricelisthelp.vue"
export default component.exports